import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlangedConnection = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 50,
	viewBox: "0 0 20.0 50.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 0.0 50.0 M 20.0 0.0 L 20.0 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgFlangedConnection;
